import { Message } from 'lib-shared-legacy-types';

import TextMessage, { TextMessageProps } from './TextMessage';
import { useTranslatePlainTextConversationMessage } from './utils/useTranslatePlainTextConversationMessage';

type MessageTranscriptProps = {
  message: Message;
} & TextMessageProps;

export const MessageTranscript = (
  props: MessageTranscriptProps,
): JSX.Element => {
  const { button, translation } = useTranslatePlainTextConversationMessage({
    text: props.message.text ?? undefined,
    isDisabled: false,
    originalLanguageCode: props.message.language ?? null,
  });

  return (
    <TextMessage
      {...props}
      content={props.message.text}
      gutterButtons={button}
      translation={translation}
    />
  );
};
